import _ from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { isManager } from 'modules/employees/lib/utils'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { userIsTeamLead } from 'modules/teams/store/userIsTeamLead'

export default function useGroupFieldsByPermissions() {
  const { employee } = useCurrentSession()
  const userPermissions: string[] = []
  const groupFiltersFields = [
    {
      label: i18n.t('filters.group_filters.fields.office'),
      value: 'location_id',
      type: 'string',
      permissions: ['everyone'],
    },
    {
      label: i18n.t('filters.group_filters.fields.team'),
      value: 'team_id',
      type: 'string',
      permissions: ['everyone'],
    },
    {
      label: i18n.t('filters.group_filters.fields.manager'),
      value: 'manager_id',
      type: 'string',
      permissions: ['everyone'],
    },
  ]
  const allGroupFiltersFields = [
    {
      label: i18n.t('filters.group_filters.fields.legalentity'),
      value: 'legal_entity',
      type: 'string',
      permissions: ['legalEntity'],
    },
    {
      label: i18n.t('filters.group_filters.fields.timeoffmanager'),
      value: 'timeoff_manager_id',
      type: 'string',
      permissions: ['manager', 'teamLead'],
    },
    {
      label: i18n.t('filters.group_filters.fields.timeoffpolicy'),
      value: 'timeoff_policy_id',
      type: 'string',
      permissions: ['manager'],
    },
    {
      label: i18n.t('filters.group_filters.fields.jobtitle'),
      value: 'job_title',
      type: 'string',
      permissions: ['contract'],
    },
    {
      label: i18n.t('filters.group_filters.fields.jobrole'),
      value: 'job_role',
      type: 'string',
      permissions: ['contract'],
    },
    {
      label: i18n.t('filters.group_filters.fields.hiringmonth'),
      value: 'hired_on',
      type: 'string',
      permissions: ['contract'],
    },
    {
      label: i18n.t('filters.group_filters.fields.hiringyear'),
      value: 'hired_year',
      type: 'string',
      permissions: ['contract'],
    },
    {
      label: i18n.t('filters.group_filters.fields.gender'),
      value: 'gender',
      type: 'string',
      permissions: ['personal'],
    },
    {
      label: i18n.t('filters.group_filters.fields.nationality'),
      value: 'nationality',
      type: 'string',
      permissions: ['personal'],
    },
    {
      label: i18n.t('filters.group_filters.fields.city'),
      value: 'city',
      type: 'string',
      permissions: ['personal'],
    },
    {
      label: i18n.t('filters.group_filters.fields.country'),
      value: 'country',
      type: 'string',
      permissions: ['personal'],
    },
  ]

  if (users.current.policy.can('apiCore.companySeeLegalEntityEmployees')) {
    userPermissions.push('legalEntity')
  }

  if (users.current.policy.can('contracts.contractEditContractsSettings')) {
    userPermissions.push('contract')
  }

  if (isManager(employee)) {
    userPermissions.push('manager')
  }

  if (users.current.employee && userIsTeamLead(teams, memberships, users.current.employee.id)) {
    userPermissions.push('teamLead')
  }

  _.forEach(allGroupFiltersFields, (field) => {
    if (
      _.some(userPermissions, (userPermission) => _.includes(field.permissions, userPermission))
    ) {
      groupFiltersFields.push(field)
    }
  })

  const groupOrderFields = [
    {
      label: i18n.t('filters.group_filters.ordering.a_z'),
      value: 'asc',
    },
    {
      label: i18n.t('filters.group_filters.ordering.z_a'),
      value: 'desc',
    },
  ]

  return [groupFiltersFields, groupOrderFields] as const
}
